import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { setNewForm } from 'apps/promo/actions/formAction';
import BaseLayoutPromo from 'apps/promo/components/common/BaseLayoutPromo';
import { PromoInfoPage } from 'apps/promo/components/common/PromoInfoPage/PromoInfoPage';
import PromoFailed from 'apps/promo/components/common/PromoStatus/PromoFailed';
import { getField } from 'apps/promo/components/form-multi/utils';
import Success from 'apps/promo/components/sharedComponents/status/Success';
import Waiting from 'apps/promo/components/sharedComponents/status/Waiting';
import BasePageForNoAuth from 'apps/promo/components/utils/BasePageForNoAuth';
import ModalNew from 'apps/promo/components/utils/ModalNew';
import { STATUS_OK } from 'apps/promo/constants/Constants';
import { SMS_ON_SUCCESS_PAY_FORM_NAME } from 'apps/promo/constants/formName';
import { AUTH_PAY_NOTIFICATION_ACTION, AUTH_SEND_MAIN_LINK } from 'apps/promo/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/promo/hooks/selectors';

const StatusNoAuthPage = (props) => {
    const messages = usePageMessages();
    const modalRef = useRef();
    const { special_error_code, show_additional_check_button } = useExtra();

    const getStatus = () => {
        return props.data?.status ? props.data?.status : props.data?.extra?.payment_status;
    };

    useEffect(() => {
        if (props.data.smsOnSuccessPay) {
            props.setNewForm(
                SMS_ON_SUCCESS_PAY_FORM_NAME,
                {
                    id: getField('id', props.data.smsOnSuccessPay.id, null, true, false),
                    phone: getField('phone', '', null, true, false, messages.sendPhonePlaceholder, 'tel'),
                    text: getField('text', messages.sendTextText, null, true, false, messages.sendTextPlaceholder, 'text'),
                },
                AUTH_PAY_NOTIFICATION_ACTION,
            );
        }
    }, []);

    const status = getStatus();

    if (special_error_code) {
        return (
            <PromoInfoPage
                animatedIconFail
                headerText={messages.error_title}
                secondaryText={messages.error_description}
                primaryButtonType="reactLink"
                primaryButtonCaption={show_additional_check_button ? messages.additional_check_button : ''}
                primaryButtonLink={`/auth/user-error?code=${special_error_code}`}
                topButtonCaption={messages.cancelText}
                topButtonType="link"
                topButtonLink={AUTH_SEND_MAIN_LINK}
            />
        );
    } else {
        return (
            <BaseLayoutPromo>
                {status && status.status > STATUS_OK && <PromoFailed status={status} />}
                {status && status.status === STATUS_OK && (
                    <Success
                        smsOnSuccessPay={props.data.smsOnSuccessPay}
                        showSendSMSNotificationBlock={status.showSendSMSNotificationBlock}
                        status={status}
                        modalRef={modalRef}
                    />
                )}
                {(!status || status?.status < STATUS_OK) && <Waiting smsOnSuccessPay={props.data.smsOnSuccessPay} status={status} />}
                <ModalNew ref={modalRef} />
            </BaseLayoutPromo>
        );
    }
};

export default connect(null, { setNewForm })(BasePageForNoAuth(StatusNoAuthPage));
